module.exports = __webpack_public_path__ + "img/eg2.7ba4bdea.png";